import {taxService} from "@/modules/payments/services/taxService.js";
const state = {
  taxes: [],
};

const getters = {
  taxes: (state) => state.taxes,
};

const mutations = {
  setTaxes(state, taxes) {
    state.taxes = taxes
  },
}

const actions = {
  async loadTaxes({commit, state}) {
    let hasMore = true
    let page = 0;
    let taxesArray = []
    while(hasMore) {
      let taxes = await taxService.list({page: page, per_page: 25});
      Array.prototype.push.apply(taxesArray,taxes.data.taxes);
      if (taxes.data.taxes.length === 25) {
        hasMore = true;
        page++
      } else {
        hasMore = false
      }
    }
    commit('setTaxes', taxesArray)
    return taxesArray
  },
  async createTax({commit, state},tax) {
    try{
      let taxData = (await taxService.create(tax)).data
      commit('setTaxes', [...state.taxes, taxData.tax])
      return taxData.tax
    }
    catch (e) {
      return e
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
